export const getNowInSeconds = (offset = 0) =>
  Math.floor(Date.now() / 1000) + offset;

export const calculateNewExpiresAt = (expiresIn: number | string) =>
  getNowInSeconds() + Number(expiresIn);

export const getSecondsLeftUntilExpiresAt = (expiresAt: number) =>
  expiresAt - getNowInSeconds();
